import { QUERY_EDITOR_PARAM, GUIDE_TYPE } from 'yeself-common/ModelConstant';

export const guideQueryByType = (type) => {
    switch (type) {
        case GUIDE_TYPE.INTERACTION_COLLECTOR:
            return QUERY_EDITOR_PARAM.COLLECTORID;
        case GUIDE_TYPE.ERROR_COLLECTOR:
            return QUERY_EDITOR_PARAM.COLLECTORID;
        case GUIDE_TYPE.APPLICATION_AUGMENTATION:
            return QUERY_EDITOR_PARAM.APPLICATION_AUGMENTATION_ID;
        case GUIDE_TYPE.TOUR:
        default:
            return QUERY_EDITOR_PARAM.TOURID;
    }
};

export const selectGuideLanguageCode = (guide, contentLanguageCode) => {
    if (guide.name[contentLanguageCode]) {
        return contentLanguageCode;
    }
    if (guide.name.en) {
        return 'en';
    }

    return Object.keys(guide.name)[0];
};
